import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "./sideBar.scss";

const Sidebar = () => {
  const [openMenu, setOpenMenu] = useState(null);
  const navigate = useNavigate();

  const toggleMenu = (menu) => setOpenMenu(openMenu === menu ? null : menu);

  const handleLogout = () => {
    localStorage.removeItem("isAdmin");
    navigate("/admin/login");
  };

  return (
    <aside className="erp-sidebar">
      <div className="sidebar-header">
        <div className="logo-box">
          <span className="logo-text">
            SV<span className="highlight">GOLD</span>
          </span>
          <span className="erp-badge">Manufacturing ERP</span>
        </div>
      </div>

      <nav className="sidebar-nav">
        <NavLink
          to="/admin"
          end
          className={({ isActive }) =>
            isActive ? "nav-link active" : "nav-link"
          }
        >
          <span className="icon">📊</span> Dashboard
        </NavLink>

        <div className="menu-group">
          <div
            className={`menu-title ${openMenu === "products" ? "expanded" : ""}`}
            onClick={() => toggleMenu("products")}
          >
            <span className="icon">💍</span> Master Products
            <span className="chevron">▾</span>
          </div>
          {openMenu === "products" && (
            <div className="submenu fade-in-down">
              <NavLink to="/admin/products" className="sub-link">
                Inventory
              </NavLink>
              <NavLink to="/admin/products/add" className="sub-link">
                Add Master
              </NavLink>
            </div>
          )}
        </div>

        <div className="menu-group">
          <div
            className={`menu-title ${openMenu === "orders" ? "expanded" : ""}`}
            onClick={() => toggleMenu("orders")}
          >
            <span className="icon">📦</span> Order Management
            <span className="chevron">▾</span>
          </div>
          {openMenu === "orders" && (
            <div className="submenu fade-in-down">
              <NavLink to="/admin/party-orders" className="sub-link">
                Active Orders
              </NavLink>
              <NavLink to="/admin/create-order" className="sub-link">
                Create Party Order
              </NavLink>
            </div>
          )}
        </div>

        <NavLink
          to="/admin/parties"
          className={({ isActive }) =>
            isActive ? "nav-link active" : "nav-link"
          }
        >
          <span className="icon">🏢</span> B2B Parties
        </NavLink>

        <NavLink
          to="/admin/karigars"
          className={({ isActive }) =>
            isActive ? "nav-link active" : "nav-link"
          }
        >
          <span className="icon">🔨</span> Karigar Allocation
        </NavLink>
      </nav>

      <div className="sidebar-footer">
        <div className="user-profile">
          <div className="avatar">SV</div>
          <div className="user-info">
            <span className="name">Admin</span>
            <span className="role">System Manager</span>
          </div>
        </div>
        <button onClick={handleLogout} className="btn-logout">
          🚪 Secure Logout
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
